import { z } from 'zod';

export const INTERNATIONAL_TRANSFER_MECHANISMS = [
    'ssc',
    'board_notification',
    'bcr',
    'explicit_consent',
    'adequacy_decision',
    'undertaking',
    'public_agreement',
    'incidental',
];

export const InternationalTransferSchema = z.object({
    id: z.string().optional(),
    mechanism: z.enum(INTERNATIONAL_TRANSFER_MECHANISMS),
    name: z.string().min(1),
    code: z.string().optional(),
    description: z.string().optional(),
    recipientCountry: z.string().optional(),
    recipientName: z.string().optional(),
    purpose: z.string().optional(),
    boardNotificationDate: z.coerce.date().optional().nullable(),
    boardNotificationNumber: z.string().optional(),
    sscText: z.string().optional(),
    sscSignedAt: z.coerce.date().optional().nullable(),
    sscNotificationDeadline: z.coerce.date().optional().nullable(),
    sscNotificationSentAt: z.coerce.date().optional().nullable(),
    safeguards: z.array(z.string()).optional(),
    status: z.enum(['active', 'inactive']).default('active'),
    customFields: z.record(z.unknown()).optional(),
});

export const CreateInternationalTransferSchema = InternationalTransferSchema.omit({ id: true });
export const UpdateInternationalTransferSchema = InternationalTransferSchema.partial();
